export default __webpack_public_path__ + "static/media/Shivraj Singh.42596577.jpg";